module.exports = __webpack_public_path__ + "static/media/16.602f9bc9.png";